import React, { useMemo } from 'react'
import styled from 'styled-components'
import Panel from '../Panel'
import { AutoColumn } from '../Column'
import { RowFixed } from '../Row'
import { TYPE } from '../../Theme'
import { usePairData } from '../../contexts/PairData'
import { formattedNum } from '../../utils'

const PriceCard = styled(Panel)`
  position: absolute;
  right: -220px;
  width: 220px;
  top: -20px;
  z-index: 9999;
  height: fit-content;
  background-color: ${({ theme }) => theme.bg1};
`

function formatPercent(rawPercent) {
  if (rawPercent < 0.01) {
    return '<1%'
  } else return parseFloat(rawPercent * 100).toFixed(0) + '%'
}

export default function UniPrice() {
  // 使用 PUSD 稳定币与 PPT/PUSD 交易对
  const pptPusdPair = usePairData('0x0A3e8322C1bC15E91cc45FdC9eBd819e4C70066c')

  const pricePPTinPUSD = useMemo(() => {
    if (!pptPusdPair) return '-'
    // 子图 pair.token0, token1 顺序未知，这里用 reserve 比例和 token0Price/token1Price 都可以
    // 直接用 token1Price 表示 1 token0 价值多少 token1；若 token1 是 PUSD，则为 PPT 单价
    const p0 = Number(pptPusdPair.token0Price)
    const p1 = Number(pptPusdPair.token1Price)
    if (isFinite(p0) && isFinite(p1)) {
      // 选择更接近 1 的一侧当作 PUSD 基底，输出 PPT 价格
      return (p0 > p1 ? p0 : p1).toFixed(4)
    }
    return '-'
  }, [pptPusdPair])

  return (
    <PriceCard>
      <AutoColumn gap="10px">
        <RowFixed>
          <TYPE.main>PPT/PUSD: {formattedNum(pricePPTinPUSD, true)}</TYPE.main>
        </RowFixed>
      </AutoColumn>
    </PriceCard>
  )
}
